import RMTable from 'components/customComponents/Controls/RMTable';
import TableSortInputFilter from 'components/customComponents/Controls/tableSortInputFilter';
import React, { useEffect, useState } from 'react';
import { StocksTableProps } from '../IngredientsConstants';

const handleTableFilter = (filterable: boolean, filterTitle: string) => (event: any) =>
  <TableSortInputFilter event={event} title={filterTitle} showSearchInput={filterable} />;

const getTableColumns: {
  accessor: string;
  Header: string;
  Filter?: (event: any) => JSX.Element;
  className?: string;
}[] = [
  {
    accessor: 'stockconc',
    Header: 'Stock Conc.',
    Filter: handleTableFilter(true, 'Stock Conc.'),
    className: 'stocks-table-alias',
  },
  {
    accessor: 'units',
    Header: 'Units',
    Filter: handleTableFilter(true, 'Units'),
    className: 'stocks-table-units',
  },
  {
    accessor: 'ph',
    Header: 'pH',
    Filter: handleTableFilter(true, 'pH'),
    className: 'stocks-table-ph',
  },
  {
    accessor: 'vendorname',
    Header: 'Vendor Name',
    Filter: handleTableFilter(true, 'Vendor Name'),
    className: 'stocks-table-vendor-name',
  },
  {
    accessor: 'vendorpart',
    Header: 'Vendor Part#',
    Filter: handleTableFilter(true, 'Vendor Part#'),
    className: 'stocks-table-vendor-part',
  },
];

export const StocksTable = (props: StocksTableProps) => {
  const { ingredientStocks, selectedIds, setSelectedIds } = props;
  const [values, setValues] = useState([]);

  useEffect(() => {
    setupTable();
  }, [props]);

  const setupTable = () => {
    const tableData = ingredientStocks?.map((ingredient) => {
      const entry = {
        stockconc: ingredient.stockConcentration,
        units: ingredient.concentrationUnits,
        ph: ingredient.stockPh,
        vendorname: ingredient.vendor?.name,
        vendorpart: ingredient.vendorPartNumber,
      };
      return entry;
    });
    if (tableData) {
      setValues(tableData);
    }
  };
  const setupTempTable = () => {
    if (values !== null) {
      return (
        <div id="stockstable-setuptemptable-wrapper" className="ingredients-table">
          <RMTable
            columns={getTableColumns}
            data={values}
            selectedIds={selectedIds}
            onCheckboxSelectionChange={setSelectedIds}
          />
        </div>
      );
    }
    return null;
  };

  return <div id='stockstable-container'>{setupTempTable()}</div>;
};
